import React, { useReducer, useEffect, useState } from "react";
import axios from "axios";
import Header from "components/header";

import { Grid, Typography } from "@material-ui/core";
import { isAlphanumeric } from "validator";
import {
  getUnique,
  validarSoloNumeros,
  obtenerNombreArchivoSinExtension,
} from "utils/utils";

import Alert from "@material-ui/lab/Alert";
import SelectorDeCarga from "components/SelectorDeCarga";

import cargaReducer, { cargaInitialState } from "reducers/cargaReducer";
import DropZone from "components/DropZone";
import Formulario from "components/Formulario";
import Modal from "components/modal";
import {
  URL_API_BASE,
  URL_API_CARGA,
  URL_API_PRESTADORES,
} from "constantes/urls";
import { URL_API_CONFIGURACION } from "constantes/urls";

export default function Carga(props) {
  const [
    {
      esCargaMasiva,
      extensionDeArchivosAceptados,
      pesoTotalDeArchivos,
      archivos,
      mensajeAlerta,
      tipoAlerta,
      abrirModal,
      fecha,
      prestador,
      alfa,
      numeroFactura,
      pbs,
      valor,
      valorConMascara,
      loading,
      prestadores,
    },
    dispatch,
  ] = useReducer(cargaReducer, cargaInitialState);
  const pesoMaximoEnMbPermitido = 100;
  const pesoMaximoPermitido = 1048576 * pesoMaximoEnMbPermitido;
  const cantidadMaximaDeArchivos = 1000;
  const mensajeParaErroPesoArchivos = `El o los archivos que usted intenta cargar sobrepasan los ${pesoMaximoEnMbPermitido} MB permitidos. Favor verifique y vuelva a intentarlo.`;
  const getStatusPortal = async () => {
    try {
      const response = await axios({
        method: "GET",
        url: `${URL_API_CONFIGURACION}/estado-cierre-portal`,
      });

      if (response) {
        if (response.status === 200) {
          if (!response.data.isOpen) {
            props.history.push("/cierre");
          }
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    getStatusPortal();
  }, []);

  const obtenerPrestadores = async () => {
    try {
      const resultado = await axios.get(URL_API_PRESTADORES);

      if (resultado.data.length > 0) {
        dispatch({
          type: "SET_STATE",
          payload: { prestadores: resultado.data },
        });
      }
    } catch (error) {
      if (error.response.status === 403) {
        props.history.push("/cierre");
      }
      console.log(error);
    }
  };
  useEffect(() => {
    if (prestadores.length === 0) {
      obtenerPrestadores();
    }
    return () => {};
  }, [prestadores]);
  const onChange = ({ target: { name, value } }) => {
    let reducer = { type: "SET_STATE", payload: { [name]: value } };
    if (name === "esCargaMasiva") {
      reducer.type = "SET_TIPO_CARGA";
    }
    dispatch(reducer);
  };

  const customOnChange = (name, value) => {
    onChange({ target: { name, value } });
  };

  const setArchivos = (archivos) =>
    dispatch({ type: "SET_STATE", payload: { archivos } });

  const limpiarFormulario = () => {
    dispatch({ type: "RESETEAR_CARGA" });
  };

  const mostrarMensajeError = (mensaje) => {
    dispatch({
      type: "SET_STATE",
      payload: { tipoAlerta: "error", mensajeAlerta: mensaje },
    });
  };

  const validarPesoMaximoDeArchivos = () => {
    if (pesoTotalDeArchivos > pesoMaximoPermitido) {
      mostrarMensajeError(mensajeParaErroPesoArchivos);
      return false;
    } else if (mensajeParaErroPesoArchivos === mensajeAlerta) {
      mostrarMensajeError("");
    }
    return true;
  };

  const validarArchivosConError = (archivosAceptados = []) => {
    // solo archivos con extensión permitida
    const archivosExtencionValida = archivosAceptados.filter(
      (archivoAceptado) => {
        const archivoSplit = archivoAceptado.name.split(".");
        const extension = archivoSplit[archivoSplit.length - 1];
        return (
          extensionDeArchivosAceptados.indexOf(extension.toLowerCase()) !== -1
        );
      }
    );

    // eliminar archivos duplicados
    const archivosSinDuplicar = getUnique(
      [...archivos, ...archivosExtencionValida],
      "path"
    );

    let esValido = true;
    if (esCargaMasiva) {
      const archivosValidados = archivosSinDuplicar.map((archivo) => {
        const archivoSplit = archivo.name.split("_");
        if (archivoSplit.length !== 5) {
          archivo.mensajeError = "No cumple con la estructura";
          esValido = false;
        } else {
          archivo.mensajeError = "";
          const nit = archivoSplit[0];
          if (!nit) {
            archivo.mensajeError = "NIT es obligatorio.";
            esValido = false;
          }
          if (nit < 4) {
            archivo.mensajeError = "NIT debe contener mínimo 4 digitos.";
            esValido = false;
          }
          if (!validarSoloNumeros(nit)) {
            archivo.mensajeError = "NIT debe ser númerico.";
            esValido = false;
          }

          const existePrestador = prestadores.some(
            (prestador) => prestador.nit.trim() === nit.trim()
          );

          // if (!existePrestador) {
          //   archivo.mensajeError = 'NIT no valido.'
          //   esValido = false
          // }

          if (archivoSplit[1] && !isAlphanumeric(archivoSplit[1])) {
            archivo.mensajeError = "Alfa debe ser alfa númerico.";
            esValido = false;
          }
          if (
            archivoSplit[1] &&
            isAlphanumeric(archivoSplit[1]) &&
            archivoSplit[1].length > 6
          ) {
            archivo.mensajeError = "Alfa debe tener máximo 6 caracteres.";
            esValido = false;
          }
          if (!archivoSplit[2]) {
            archivo.mensajeError = "Número de factura es obligatorio.";
            esValido = false;
          }
          if (!validarSoloNumeros(archivoSplit[2])) {
            archivo.mensajeError = "Número de factura debe ser númerico.";
            esValido = false;
          }

          if (!archivoSplit[3]) {
            archivo.mensajeError = "Valor es obligatorio.";
            esValido = false;
          }

          if (!validarSoloNumeros(archivoSplit[3])) {
            archivo.mensajeError = "Valor debe ser númerico.";
            esValido = false;
          }

          if (!archivoSplit[4]) {
            archivo.mensajeError = "PBS es obligatorio.";
            esValido = false;
          }

          const pbsZip = obtenerNombreArchivoSinExtension(archivoSplit[4]);

          if (
            pbsZip.toLowerCase() !== "pbs" &&
            pbsZip.toLowerCase() !== "npbs"
          ) {
            archivo.mensajeError = "Debes indicar si el archivo es PBS ó NPBS.";
            esValido = false;
          }
        }
        return archivo;
      });
      setArchivos(archivosValidados);
    } else {
      setArchivos(archivosSinDuplicar);
    }
    if (!esValido) {
      mostrarMensajeError(
        "Algunos archivos cargados no cumplen con la estructura"
      );
      window.scrollTo(0, 0);
    }
    return esValido;
  };

  const onSubmit = async (e) => {
    if (!validarPesoMaximoDeArchivos() || !validarArchivosConError()) {
      return false;
    }
    customOnChange("loading", true);

    let formData = new FormData();
    formData.append("esCargaMasiva", esCargaMasiva);
    formData.append("nit", prestador.nit.trim());
    formData.append("alfa", alfa.trim());
    formData.append("numeroFactura", numeroFactura.trim());
    formData.append("pbs", pbs);
    formData.append("valor", valor);

    archivos.map((file, index) => {
      formData.append(`archivos[${index}]`, file);
      return false;
    });

    try {
      const respuesta = await axios({
        url: URL_API_CARGA,
        method: "post",
        data: formData,
        timeout: 60 * 1000 * 20, //20 minutos antes de finalizar la petición
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      });
      if (respuesta) {
        dispatch({
          type: "SET_STATE",
          payload: {
            fecha: `${respuesta.data.fechaCarga} Carga id: ${respuesta.data.cargaId}`,
            abrirModal: true,
          },
        });
      }
      customOnChange("loading", false);
    } catch (error) {
      if (error.response.status === 403) {
        props.history.push("/cierre");
      }
      customOnChange("loading", false);
      if (!error.response) {
        mostrarMensajeError(`Error de conexión.`);
        return;
      }
      if (error.response && error.response.data && error.response.data.length) {
        var mensaje = [];
        error.response.data.map((archivoNoCargado) => {
          mensaje.push(
            `El archivo ${archivoNoCargado.nombre} presenta error: ${archivoNoCargado.error}`
          );
          return false;
        });
        mostrarMensajeError(mensaje.join(". "));
      } else {
        const logErrorId = error.response.data.logErrorId || "";
        mostrarMensajeError(
          `Ocurrió un error al realizar la carga. Contacte a soporte logErrorId: ${logErrorId}`
        );
      }
      window.scrollTo(0, 0);
    }
  };

  const mostrarAlertas = (mensajes) =>
    mensajes.map((mensaje, index) => (
      <Alert
        severity={tipoAlerta}
        onClose={() => {
          mostrarMensajeError("");
        }}
        key={index}
      >
        {mensaje}
      </Alert>
    ));

  return (
    <div style={{ padding: 20 }}>
      <Grid
        container
        justify="center"
        direction="column"
        alignItems="center"
        spacing={4}
      >
        <Header />
        <Grid item sm={8} xs={12}>
          <Alert severity="info">
            Por favor tener en cuenta al momento de la carga y nombramiento de
            las carpetas con sus facturas y soportes lo siguiente:
            <br />
            1. El Nit debe relacionarse sin digito de verificación.
            <br />
            2. No deben presentarse archivos "corruptos o dañados".
            <br />
            3. Los soportes deben estar asociados a una única factura.
            <br />
            4. Los soportes deben corresponder con el servicio o usuario que
            están facturando.
            <br />
            5. La extensión de los archivos requerida es PDF o TIF.
            <br />
            6. En el nombramiento de la carpeta sólo se deben usar letras
            Mayúsculas y la carpeta.zip no debe contener subcarpetas.
            <br />
            7. En la carga masiva se pueden arrastrar varias carpetas.zip y cada
            una de ellas debe contener imágenes de una (1) sola factura que
            corresponde a la nombrada en el Zip, esta imagen se debe identificar
            como IMGFACTURA y se debe cargar de forma separada de los soportes.
            Los soportes correspondientes a esa sola factura se deben adjuntar
            identificándolos con los nombres que utilice el prestador en su
            sistema.
            <br />
            <p>
              Les recordamos que de acuerdo con la Resolución 3047de 2008, es
              causal de devolución el no adjuntar los soportes requeridos para
              el servicio que se está facturando, es decir que en estos casos
              procede la devolución de la factura. Por lo tanto les sugerimos
              revisar muy bien que los archivos correspondan con la estructura
              definida para evitar devoluciones.
            </p>
          </Alert>
        </Grid>
        <Grid item sm={8} xs={12}>
          <Typography variant="h6">
            Haz clic{" "}
            <a href={`${URL_API_BASE}/instructivo.pdf`} target="_blank">
              aquí
            </a>{" "}
            para descargar el instructivo que te guiará de cómo hacer la carga
            de manera correcta.{" "}
          </Typography>
          <br />
          <SelectorDeCarga esCargaMasiva={esCargaMasiva} onChange={onChange} />
        </Grid>
        {/* Mensaje de alerta INICION*/}
        {mensajeAlerta && (
          <Grid item sm={8} xs={12}>
            {mostrarAlertas([mensajeAlerta])}
          </Grid>
        )}
        {/* Mensaje de alerta FIN*/}

        <Grid item sm={4}>
          <Formulario
            onSubmit={onSubmit}
            onChange={onChange}
            prestador={prestador}
            alfa={alfa}
            numeroFactura={numeroFactura}
            pbs={pbs}
            valor={valor}
            valorConMascara={valorConMascara}
            limpiarFormulario={limpiarFormulario}
            mostrarMensajeError={mostrarMensajeError}
            archivos={archivos}
            pesoMaximoPermitido={pesoMaximoPermitido}
            cantidadMaximaDeArchivos={cantidadMaximaDeArchivos}
            loading={loading}
            esCargaMasiva={esCargaMasiva}
            prestadores={prestadores}
            obtenerPrestadores={obtenerPrestadores}
          />
        </Grid>

        {/* <Form /> */}
        <Grid item>
          <DropZone
            extensionDeArchivosAceptados={extensionDeArchivosAceptados}
            pesoMaximoEnMbPermitido={pesoMaximoEnMbPermitido}
            pesoMaximoPermitido={pesoMaximoPermitido}
            archivos={archivos}
            setArchivos={setArchivos}
            loading={loading}
            mostrarMensajeError={mostrarMensajeError}
            mensajeAlerta={mensajeAlerta}
            pesoTotalDeArchivos={pesoTotalDeArchivos}
            customOnChange={customOnChange}
            validarPesoMaximoDeArchivos={validarPesoMaximoDeArchivos}
            esCargaMasiva={esCargaMasiva}
            validarArchivosConError={validarArchivosConError}
          />
        </Grid>
        <Modal open={abrirModal} btnAceptar={limpiarFormulario} fecha={fecha} />
      </Grid>
    </div>
  );
}
